import React from 'react';
import { Popover, PopoverProps } from 'antd';

type Trigger = 'hover' | 'focus' | 'click' | 'contextMenu';
export interface Props extends PopoverProps {
	children?: React.ReactNode;
	content?: string | React.ReactNode;
	title?: string | React.ReactNode;
	trigger?: Trigger | Trigger[];
	overlayClassName?: string;
	mouseEnterDelay?: number;
	placement?:
		| 'top'
		| 'left'
		| 'right'
		| 'bottom'
		| 'topLeft'
		| 'topRight'
		| 'bottomLeft'
		| 'bottomRight'
		| 'leftTop'
		| 'leftBottom'
		| 'rightTop'
		| 'rightBottom';
}

/**
 * try to use [BringgPopover](../popover/popover.tsx) to reduce antd dependency
 */
const PopOver = (props: Props) => {
	return (
		<Popover
			content={props.content}
			title={props.title}
			trigger={props.trigger}
			placement={props.placement}
			overlayClassName={props.overlayClassName}
			mouseEnterDelay={props.mouseEnterDelay}
			{...props}
		>
			{props.children}
		</Popover>
	);
};

PopOver.defaultProps = {
	placement: 'top',
	trigger: 'hover',
	title: ''
};

export default PopOver;
